import { paths } from '@/constants/paths';

import { env } from '@/env';

type CreateCheckoutURLParams = {
  email: string;
  priceId: string;
  name?: string;
  source?: 'self' | 'ghl';
};
export const createCheckoutURL = (params: CreateCheckoutURLParams) => {
  const { email, priceId, name, source } = params;
  const successUrl = `${env.NEXT_PUBLIC_APP_URL}${paths.checkout.success}?source=${source}`;
  const displayName = name || email?.split('@')[0];
  const checkoutUrl = `${env.NEXT_PUBLIC_APP_URL}${paths.checkout.index}?priceId=${priceId}&email=${email}&name=${displayName}&successUrl=${successUrl}`;
  return checkoutUrl;
};
